import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { getRequestId } from "../../../_helpers/miscUtils";
import { SuccessToast } from "../../../toast/Toasts";

export const getAllMyTrips = createAsyncThunk(
  "FlightBooking/MyTrips",
  async (user_guid: any) => {
    const response = await axiosApiInstance.post(
      `${API_URL}/FlightBooking/MyTrips`,
      user_guid
    );
    return response.data?.Data;
  }
);

export const getBookingDetails = createAsyncThunk(
  "AirlineReprint/Air_Reprint",
  async (payload: any) => {
    const Request_Id = getRequestId();
    const response = await axiosApiInstance.post(
      `${API_URL}/AirlineReprint/Air_Reprint`,
      { ...payload, Request_Id }
    );
    return response.data;
  }
);

export const getCreditNoteList = createAsyncThunk(
  "FlightBooking/FindCreditNotesByBookingNo",
  async (BookingNo: string) => {
    const response = await axiosApiInstance.post(
      `${API_URL}/FlightBooking/FindCreditNotesByBookingNo`,
      {
        portal_booking_no: BookingNo,
      }
    );
    return response.data?.Data || [];
  }
);

export const getTicketPDF = createAsyncThunk(
  "AirlineReprint/Air_ReprintPDF",
  async (payload: any) => {
    const Request_Id = getRequestId();
    const response = await axiosApiInstance.post(
      `${API_URL}/AirlineReprint/Air_ReprintPDF`,
      { ...payload, Request_Id }
    );
    return response.data;
  }
);

export const sendTicketEmailAndSMS = createAsyncThunk(
  "AirlineReprint/Sendmail",
  async (payload: any) => {
    const Request_Id = getRequestId();
    const response = await axiosApiInstance.post(
      `${API_URL}/AirlineReprint/Sendmail`,
      { ...payload, Request_Id }
    );
    SuccessToast(response.data?.Details || "Success");
    return response.data;
  }
);

export const sendInvoiceEmailAndSMS = createAsyncThunk(
  "AirlineReprint/SendInvoice",
  async (payload: any) => {
    const Request_Id = getRequestId();
    const response = await axiosApiInstance.post(
      `${API_URL}/AirlineReprint/SendInvoice`,
      { ...payload, Request_Id }
    );
    SuccessToast(response.data?.Details || "Success");
    return response.data;
  }
);
